import { orchestrator } from '../clients.ts'
import { createCommand, newCommandId } from '../command.ts'
import { keys } from '../keys.ts'
import type { AlarmRemoteSetting } from '../queries/alarmRemote.ts'

export const useUpdateAlarmRemoteSetting = createCommand<
  { enabled: boolean; commandId?: string },
  AlarmRemoteSetting
>({
  send: ({ enabled, commandId }) =>
    orchestrator.request<AlarmRemoteSetting>({
      method: 'PUT',
      path: '/settings/alarm-remote',
      body: { command_id: commandId ?? newCommandId(), enabled },
      retryOn401: true,
    }),
  invalidates: () => [keys.alarmRemote.all()],
})
